import CryptoJS from "crypto-js";
import { jwtDecode } from "jwt-decode";
import { decryptToken } from "../../../Components/utils/getToken";
import { getSessionMainId } from "../../../Components/utils/getCookie";

export function persistAdminSession({ accessToken, token, user }) {
  const jwt = accessToken || token;
  if (jwt) localStorage.setItem("accessToken", jwt);

  const secret = process.env.REACT_APP_CRYPTO_SECRET;
  if (!secret || !user) return;

  const payload = {
    id: user.id,
    email: user.email,
    full_name: user.full_name,
    type: user.type || user.role || "Admin",
    main_id: user.main_id,
    status: user.status || "Active",
    category: user.category || "",
  };

  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(payload), secret).toString();
  localStorage.setItem("2xgxgshdugyywerw12eccom", JSON.stringify(encrypted));
}

export function isAdminLoggedIn() {
  const mainId = getSessionMainId();
  const token = decryptToken("accessToken");
  if (!mainId || !token) return false;
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp && decoded.exp * 1000 < Date.now()) return false;
    return true;
  } catch {
    return false;
  }
}
